import {apiClient} from "./api-client";
import type {components} from "./api-types";

// ============================================================================
// Types - re-exported from generated OpenAPI types
// ============================================================================

export type WidgetCreate = components["schemas"]["WidgetCreate"];
export type WidgetResponse = components["schemas"]["WidgetResponse"];
export type WidgetListResponse = components["schemas"]["WidgetListResponse"];

// Widget type extracted from WidgetCreate
export type WidgetType = WidgetCreate["widget_type"];

// ============================================================================
// API Functions
// ============================================================================

/**
 * List user's widgets, optionally filtered by widget type
 */
export async function listWidgets(
  widgetType?: WidgetType,
  skip?: number,
  limit?: number
): Promise<WidgetListResponse> {
  const {data, error} = await apiClient.GET("/api/widgets", {
    params: {
      query: {
        widget_type: widgetType,
        skip,
        limit,
      },
    },
  });

  if (error || !data) {
    throw new Error((error as {detail?: string})?.detail || "Failed to fetch widgets");
  }

  return data;
}

/**
 * Create a new widget
 */
export async function createWidget(request: WidgetCreate): Promise<WidgetResponse> {
  const {data, error} = await apiClient.POST("/api/widgets", {
    body: request,
  });

  if (error || !data) {
    throw new Error((error as {detail?: string})?.detail || "Failed to create widget");
  }

  return data;
}

/**
 * Get a widget by ID
 */
export async function getWidget(widgetId: string): Promise<WidgetResponse> {
  const {data, error} = await apiClient.GET("/api/widgets/{widget_id}", {
    params: {
      path: {widget_id: widgetId},
    },
  });

  if (error || !data) {
    throw new Error((error as {detail?: string})?.detail || "Widget not found");
  }

  return data;
}

/**
 * Delete a widget
 */
export async function deleteWidget(widgetId: string): Promise<void> {
  const {error} = await apiClient.DELETE("/api/widgets/{widget_id}", {
    params: {
      path: {widget_id: widgetId},
    },
  });

  if (error) {
    throw new Error((error as {detail?: string})?.detail || "Failed to delete widget");
  }
}
